// src/components/seller/orders/WalletBlockedModal.js

import React from "react";
import { useNavigate } from "react-router-dom";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import "../../../assets/css/seller/screens/SellerOrderManagement.css";

const WalletBlockedModal = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="wbm-backdrop" onClick={onClose} />
      <div className="wbm-modal" role="dialog" aria-modal="true">
        <button className="wbm-close" onClick={onClose} aria-label="Close">
          <FiX size={18} />
        </button>

        <div className="wbm-icon-wrap">
          <FiAlertTriangle size={28} className="wbm-icon" />
        </div>

        <h3 className="wbm-title">Insufficient Wallet Balance</h3>
        <p className="wbm-desc">
          Your wallet balance is zero. Please top up to view order details.
        </p>

        <div className="wbm-actions">
          <button className="wbm-btn-cancel" onClick={onClose}>
            Cancel
          </button>
         <button
  className="wbm-btn-topup"
  onClick={() => navigate("/seller/earnings")}
>
  Top Up Now
</button>
        </div>
      </div>
    </>
  );
};

export default WalletBlockedModal;
